<template>
  <div id="headerId">
    <el-container>
      <el-header class="header_class">
        <el-menu class="header_image">
          <el-menu-item index="1" class="header_image_style text_style">
            <img
              @click="backMyproJect"
              class="header_image_sty"
              src="../assets/img/header/developer_header.png"
              alt
            >
          </el-menu-item>
        </el-menu>
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="2">
            <span
              @click="headerNavMainFunc('MyProjectsList')"
              :class="{ navSpanClass: isFlagSpanClass === 'MyProjectsList' }"
              class="text_style _header_margin _header_nav_text _header_nav_text_margin"
            >{{ $t('table.common.thirdNav.myprojects.title') }}</span>
          </el-menu-item>
          <el-menu-item index="9">
            <span class="_span_text_sty text_style">|</span>
          </el-menu-item>
          <el-menu-item index="3">
            <span
              style="cursor: not-allowed;"
              @click="headerNavMainFunc('appAnalysis')"
              :class="{ navSpanClass: isFlagSpanClass === 'appAnalysis' }"
              class="text_style _header_margin _header_nav_text _header_nav_text_margin _header_nav_text_margin_no"
            >{{ $t('table.common.thirdNav.appAnalysis.title') }}</span>
          </el-menu-item>
          <el-menu-item index="10">
            <span class="_span_text_sty text_style">|</span>
          </el-menu-item>
          <el-menu-item index="4">
            <span
              style="cursor: not-allowed;"
              @click="headerNavMainFunc('financialStatistics')"
              :class="{ navSpanClass: isFlagSpanClass === 'financialStatistics' }"
              class="text_style _header_margin _header_nav_text _header_nav_text_margin _header_nav_text_margin_no"
            >{{ $t('financialStatistics.header.title') }}</span>
          </el-menu-item>
          <el-menu-item index="11">
            <span class="_span_text_sty text_style">|</span>
          </el-menu-item>
          <el-menu-item index="5" style="margin-right: 98px;">
            <span
              style="cursor: not-allowed;"
              @click="headerNavMainFunc('orderManagment')"
              :class="{ navSpanClass: isFlagSpanClass === 'orderManagment' }"
              class="text_style _header_margin _header_nav_text _header_nav_text_margin _header_nav_text_margin_no"
            >{{ $t('table.common.thirdNav.orderManagment.title') }}</span>
          </el-menu-item>
          <!-- 开发文件 -->
          <el-menu-item index="6" class="fileBox">
            <img
              :class="{ marginTop:mouseoverFileFlag === true }"
              class="text_style _project_img_sty _header_nav_text _header_margin"
              src="../assets/img/header/style_file.png"
              alt
            >
            <div
              @mousedown="mousedownFunc('fileSty', '0', fileUrl)"
              @mouseup="mouseupFunc('fileSty', '0', fileUrl)"
              @mouseenter="mouseenterIcon('0')"
              @mouseleave="mouseleaveIcon('0')"
              style="width: 30px;margin: auto;height: 50px;position: absolute;top: 12px;cursor: pointer; left: -5px;"
            ></div>
          <el-collapse-transition>
            <div
              @mouseenter="mouseenterIcon('0')"
              @mouseleave="mouseleaveIcon('0')"
              class="fileSelect"
              v-show="mouseoverFileFlag"
            >
              <div>
                <div class="rightBoxA"></div>
                <div class="rightBox"></div>
                <ul class="fileSelectUl">
                  <li
                    @mousedown="mousedownFunc('fileSty', '1', fileUrl)"
                    @mouseup="mouseupFunc('fileSty', '1', fileUrl)"
                    :class="{ navLiClass: isFlagIconClass === 'fileSty' }"
                  >{{ $t('file') }}</li>
                  <li
                    @mousedown="mousedownFunc('toolSty', '1', toolUrl)"
                    @mouseup="mouseupFunc('toolSty', '1', toolUrl)"
                    class="closeSty"
                  >{{ $t('userHeader.option.file.tool') }}</li>
                  <li
                    @mousedown="mousedownFunc('bbsSty', '1', bbsUrl)"
                    @mouseup="mouseupFunc('bbsSty', '1', bbsUrl)"
                    :class="{ navLiClass: isFlagIconClass === 'bbsSty' }"
                  >{{ $t('footer.forums') }}</li>
                </ul>
              </div>
            </div>
          </el-collapse-transition>
          </el-menu-item>
          <el-menu-item index="12">
            <span class="_span_img_sty text_style">|</span>
          </el-menu-item>
          <!-- 消息通知 -->
          <el-menu-item index="7" class="">
            <img
              :class="{ marginTop:mouseoverInfoFlag === true }"
              class="_info_img_sty _header_nav_text _header_margin"
              src="../assets/img/header/style_info.png"
              alt
            >
            <div
              @click="headerNavMainFunc('infoBox')"
              @mousedown="mousedownFunc('infoBox', '0')"
              @mouseup="mouseupFunc('infoBox', '0')"
              @mouseenter="mouseenterIcon('1', true)"
              @mouseleave="mouseleaveIcon('1')"
              style="width: 30px;margin: auto;height: 50px;position: absolute;top: 12px;cursor: pointer;"
            ></div>
          <el-collapse-transition>
            <div
              @mouseenter="mouseenterIcon('1')"
              @mouseleave="mouseleaveIcon('1')"
              class="infoSelect"
              v-show="mouseoverInfoFlag"
            >
              <div>
                <div class="rightBoxA"></div>
                <div class="rightBox"></div>
                <ul class="infoSelectUl" v-loading="loading">
                  <li
                    v-show="isInfoItem"
                    @click="notificationFunc(o)"
                    v-for="(o, index) in notificationMessage"
                    :key="index"
                    class="notificationMessageItem"
                    :style=" index === notificationMessage.length - 1 ? 'border-bottom: none;' : '' "
                  >
                    <h1
                      style=" font-size: 12px;font-weight: 600;line-height: 18px;margin-bottom:2px;"
                    >{{o.notification.title}}</h1>
                    <div
                      style="display:flex;font-size: 12px;font-weight: 300;opcity:.5;line-height: 18px;"
                    >
                      <p>{{o.notification.message.length > 15 ? o.notification.message.substring(0, 15) + '...' : o.notification.message}}</p>
                      <span style="display:flex;flex-grow:1;"></span>
                      <span>{{ momentFunc(o.notification.createdAt) }}</span>
                    </div>
                  </li>
                  <div v-show="!isInfoItem" style="height: 124px;">
                    <img
                      class="noMessageImg"
                      src="../assets/img/header/nuwa_developer_infobox.png"
                      alt
                    >
                    <p class="noMessageClass">{{ $t('userHeader.option.info.message') }}</p>
                  </div>
                  <li
                    @click="headerNavMainFunc('infoBox')"
                    @mousedown="mousedownFunc('infoBox', '1')"
                    @mouseup="mouseupFunc('infoBox', '1')"
                    :class="{ navLiClass: isFlagIconClass === 'infoBox11' }"
                    class="toTheNews"
                  >{{ $t('userHeader.option.info.com') }}</li>
                </ul>
              </div>
            </div>
          </el-collapse-transition>
          </el-menu-item>
          <el-menu-item index="13">
            <span class="_span_img_sty text_style">|</span>
          </el-menu-item>
          <!-- 我的账户 -->
          <el-menu-item index="8" class="accountPosition">
            <img
              :class="{ marginTop:mouseoverAccountFlag === true }"
              class="_account_img_sty _header_nav_text _header_margin"
              src="../assets/img/header/white_account_icon.png"
              alt
              style="width:22px;"
            >
            <div
              @click="headerNavMainFunc('myAccount')"
              @mousedown="mousedownFunc('myAccount', '0')"
              @mouseup="mouseupFunc('myAccount', '0')"
              @mouseenter="mouseenterIcon('2')"
              @mouseleave="mouseleaveIcon('2')"
              style="width: 30px;margin: auto;height: 50px;position: absolute;top: 12px;cursor: pointer; left: -5px;"
            ></div>
            <el-collapse-transition>
            <div
              @mouseenter="mouseenterIcon('2')"
              @mouseleave="mouseleaveIcon('2')"
              class="accountSelect"
              v-show="mouseoverAccountFlag"
            >
              <div>
                <div class="rightBoxA"></div>
                <div class="rightBox"></div>
                <ul class="accountSelectUl">
                  <li
                    @mousedown="mousedownFunc('myAccount', '1')"
                    @mouseup="mouseupFunc('myAccount', '1')"
                    :class="{ navLiClass: isFlagIconClass === 'myAccount' }"
                  >{{ $t('userHeader.option.account.user') }}</li>
                  <li
                    @mousedown="mousedownFunc('logOut', '1')"
                    @mouseup="mouseupFunc('logOut', '1')"
                    :class="{ navLiClass: isFlagIconClass === 'logOut' }"
                    style="text-align:left;"
                  >{{ $t('loginOut') }}</li>
                </ul>
              </div>
            </div>
          </el-collapse-transition>
          </el-menu-item>
          <el-menu-item index="14" style="cursor: default;">
            <div class="_search_header_sty" style="visibility: hidden;"></div>
          </el-menu-item>
        </el-menu>
      </el-header>
      <SecondFloor/>
      <IconNavHeader/>
    </el-container>
    <ThirdNavigation/>
  </div>
</template>
<script>
// 第二层
import moment from 'moment'
// import api from '../api'
import SecondFloor from '../views/SecondFloor.vue'
import IconNavHeader from '../views/IconNavHeader.vue'
import ThirdNavigation from '../views/ThirdNavigation.vue'
export default {
    components: {
        SecondFloor,
        IconNavHeader,
        ThirdNavigation
    },
    data () {
        let protocol = window.location.protocol
        let env = window.location.hostname
        let url = protocol + '//' + env
        return {
            activeIndex: '2',
            dropdown_menu: false,
            mouseoverAccountFlag: false,
            mouseoverFileFlag: false,
            mouseoverInfoFlag: false,
            isFlagIconClass: '',
            routes: [],
            // fileUrl: 'http://dss.nuwarobotics.com/documents/listApp',
            // port: '8070',
            fileUrl: env === 'localhost' ? url + ':' + '8070' + '/documents/intro' : url + '/documents/intro',
            // bbsUrl: 'http://dev-dss.nuwarobotics.com/forum/',
            bbsUrl: url + '/forum/',
            toolUrl: 'http://dev-dss.nuwarobotics.com/tool/',
            notificationMessage: [],
            isInfoItem: !true,
            loading: false,
            unClickArr: ['appAnalysis', 'financialStatistics', 'orderManagment'],
            url: url,
            env: env
        }
    },
    methods: {
        // 转换时间
        momentFunc (date, type) {
            if (!date) {
                return
            }
            if (type) {
                return moment(date).format('YYYY/MM/DD')
            }

            if (
                parseInt(moment(date).format('YYYY')) <
                parseInt(moment(new Date()).format('YYYY'))
            ) {
                return moment(date).format('YYYY')
            } else if (
                moment(date).format('MM/DD') ===
                moment(new Date()).format('MM/DD')
            ) {
                return moment(date).format('h:mma')
            } else if (
                moment(new Date()).format('MM') === moment(date).format('MM') &&
                parseInt(moment(new Date()).format('DD')) -
                    parseInt(moment(date).format('DD')) <=
                    7
            ) {
                return moment(date)
                    .startOf('day')
                    .fromNow()
            }
            return moment(date).format('MM/DD')
        },
        handleSelect (key, keyPath) {},
        loginOutFn () {
            localStorage.removeItem('token')
            this.$store.state.token = null
            sessionStorage.removeItem('registeredDetail')
            this.$store.state.registeredDetail = null
            this.$store.state.isSideBarShow = null
            sessionStorage.removeItem('isSideBarShow')
            this.$router.push({ name: 'userLogin' })
            this.isFlagIconClass = null
            this.$store.state.borderStyle = 'login'
            localStorage.setItem('clickState', 'login')
        },
        mouseupFunc (to, type, url) {
            if (to === 'logOut') {
                // this.$confirm(`${this.$t('message.prompt.common.content.logOut')} ${this.$t('message.prompt.common.title.continue')}`, this.$t('message.prompt.common.title.NWTeam'), {
                //     confirmButtonText: this.$t('message.prompt.common.title.tool.ok'),
                //     cancelButtonText: this.$t('userRoles.common.dialog.button.cancle'),
                //     type: 'warning'
                // }).then(() => {
                this.loginOutFn()
                // }).catch(() => {
                //     this.isFlagIconClass = null
                // })
                return
            }
            if (url && type === '0') {
                this.isFlagIconClass = null
                window.location.href = url
            } else if (url && type === '1') {
                // if (to === 'bbsSty') {
                if (to === 'toolSty') {
                    // 工具暂未开放
                    return
                }
                window.location.href = url
                // } else {
                //     this.$router.push({ name: 'listApp' })
                // }
                this.isFlagIconClass = null
            } else {
                if (type === '0') {
                    this.isFlagIconClass = null
                } else {
                    this.headerNavMainFunc('myAccount')
                }
            }
            this.$store.state.isFlagSpanClass = null
        },
        mousedownFunc (to, type, url) {
            if (to === 'logOut') {
                this.isFlagIconClass = to
                return
            }
            if (url && type === '0') {
                this.isFlagIconClass = null
            } else if (url && type === '1') {
                this.isFlagIconClass = to
            } else {
                if (type === '0') {
                    this.isFlagIconClass = null
                } else {
                    this.isFlagIconClass = to
                }
            }
        },
        // myProJect
        backMyproJect () {
            // console.log(this.url, this.env)
            let path = this.env === 'localhost' ? this.url + ':' + '8070' : this.url
            // console.log(path)
            window.location.href = path
            // this.$router.push({ name: 'MyProjectsList' })
        },
        mouseenterIcon (type, flag) {
            if (type === '0') {
                this.mouseoverFileFlag = true
            } else if (type === '1') {
                if (flag) {
                    this.getInfoData()
                }
                this.mouseoverInfoFlag = true
            } else {
                this.mouseoverAccountFlag = true
            }
        },
        mouseleaveIcon (type) {
            if (type === '0') {
                this.mouseoverFileFlag = false
            } else if (type === '1') {
                this.mouseoverInfoFlag = false
            } else {
                this.mouseoverAccountFlag = false
            }
        },
        // header 导航事件
        headerNavMainFunc (path) {
            let flag = this.unClickArr.some(s => s === path)
            if (flag) return
            this.isFlagIconClass = null
            this.routes.forEach(item => {
                if (item.path === path) {
                    this.navRouterState(item)
                }
            })
        },
        // get data function
        getInfoData () {
            this.loading = true
            // 这是请求infoData
            let path =
                '/developer/notifications'
            // const headers = { authorization: localStorage.getItem('token') }
            this._api.request('get', path)
                .then(response => {
                    if (response.status === 200) {
                        let data = response.data.data.payload
                        !data.length && (this.isInfoItem = false)
                        data.length && (this.isInfoItem = true)
                        this.notificationMessage = data.slice(0, 5)
                        this.loading = false
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        notificationFunc (id) {
            this.$router.push({
                name: 'infoBox',
                params: {
                    id
                }
            })
        }
    },
    mounted () {
        let routes = this.$router.options.routes
        this.routes = routes
            .filter(
                item =>
                    item.hasOwnProperty('meta') &&
                    item.meta.hasOwnProperty('navObj')
            )
            .map(item => item.meta.navObj)
    },
    computed: {
        isFlagSpanClass () {
            return this.$store.state.isFlagSpanClass
        },
        isFlagLiClass () {
            return this.$store.state.isFlagLiClass
        }
    }
}
</script>
<style scoped>
li {
    list-style: none;
}
ul,
p,
h1 {
    padding: 0px;
    margin: 0px;
}
.marginTop {
    margin-bottom: 4px !important;
}
/* 消息中心 */
.notificationMessageItem {
    text-align: left !important;
    padding-top: 5px !important;
    padding-bottom: 12px !important;
    border-bottom: 1px solid rgba(51, 51, 51, 0.3);
}
.noMessageImg {
    width: 81px;
    margin: auto;
    padding: 22px 0px;
    display: block;
}
.noMessageClass {
    height: 22px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.7px;
    text-align: center;
    line-height: 22px;
    color: #333333;
    display: block;
    margin-bottom: 14px;
}
.toTheNews {
    text-align: center !important;
    font-size: 16px !important;
    color: rgba(0, 181, 226, 0.8) !important;
    font-weight: 900 !important;
    padding-top: 11px !important;
    padding-bottom: 9px !important;
    border-top: 1px solid rgba(51, 51, 51, 0.3);
}
.rightBox {
    width: 0;
    height: 0;
    border-width: 0 5px 5px;
    border-style: solid;
    border-color: transparent transparent #fff;
    margin: 0px auto;
    top: 1px;
    position: relative;
    z-index: 1;
}
.rightBoxA {
    width: 0;
    height: 0;
    border-width: 0 6px 6px;
    border-style: solid;
    border-color: transparent transparent rgba(51, 51, 51, 0.2);
    margin: 0px auto;
    position: relative;
    top: 5.8px;
    left: -0.2px;
}
.fileBox {
    position: relative;
}
.fileSelect {
    position: absolute;
    top: 55px;
    left: -16px;
    z-index: 3;
}
.accountSelect {
    position: absolute;
    top: 55px;
    left: -26px;
    z-index: 3;
}
.infoSelect {
    position: absolute;
    top: 55px;
    left: -96px;
    z-index: 3;
    width: 220px;
}
.fileSelectUl li {
    text-align: center;
    width: 54px;
    height: 28px;
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 28px;
    letter-spacing: 0.7px;
    color: #333333;
    cursor: pointer;
}
.fileSelectUl {
    padding-top: 6px;
    padding-bottom: 4px;
    border: solid 1px rgba(51, 51, 51, 0.2);
    border-radius: 5px;
    background-color: #ffffff;
}
.accountSelectUl {
    padding-top: 6px;
    padding-bottom: 4px;
    border: solid 1px rgba(51, 51, 51, 0.2);
    border-radius: 5px;
    background-color: #ffffff;
}
.infoSelectUl {
    padding-top: 6px;
    border: solid 1px rgba(51, 51, 51, 0.2);
    border-radius: 5px;
    background-color: #ffffff;
}
.accountSelectUl li {
    height: 28px;
    text-align: center;
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 28px;
    letter-spacing: 0.7px;
    color: #333333;
    padding: 0px 10px;
    cursor: pointer;
}
.infoSelectUl li {
    text-align: center;
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 28px;
    letter-spacing: 0.7px;
    color: #333333;
    padding: 0px 10px;
    cursor: pointer;
}
.fileSelectUl li:hover {
    background-color: rgba(0, 224, 218, 0.1);
}

.accountSelectUl li:hover {
    background-color: rgba(0, 224, 218, 0.1);
}

.infoSelectUl li:hover {
    background-color: rgba(0, 224, 218, 0.1);
}
/* 暂未开放 */
.closeSty:hover{
    background: #fff!important;
    opacity: .5;
    cursor: not-allowed;
}
.navLiClass {
    color: #00b5e2 !important;
    font-weight: 500 !important;
    box-sizing: border-box;
}
.accountPosition {
    position: relative;
}

#headerId {
    width: 1280px;
    position: fixed;
    z-index: 2;
}

.hint {
    opacity: 0.5;
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.7px;
    color: #333333;
}

.header_image {
    float: left;
    border: none;
}

.el-dropdown {
    margin-right: 40px;
    line-height: 40px;
    color: #fff;
}
.el-dropdown:hover {
    color: #00b5e2;
}
.firstDropDown {
    margin-left: 36px;
}
.header_select {
    height: 60px;
    color: #fff;
    background-color: rgba(0, 181, 226, 0.1);
}

.header_class:hover {
    background: #00b5e2 !important;
}
.header_class {
    background: #00b5e2;
}
/* 公共自定义样式  <el-dropdown-men/>*/
._dropdown_active {
    color: #00b5e2;
    outline: none;
}

._submission_process {
    height: 70px;
    background: #f8f8f8;
    line-height: 70px;
}
._margin_right {
    margin-right: 100px;
}
._cursor_pointer:hover {
    cursor: pointer;
    color: #00b5e2;
}

/* header */
.header_image_sty {
    padding: 13px 0px 15px 0px;
    margin-left: 100px;
    vertical-align: baseline;
}

.header_image_style {
    background-color: #00b5e2 !important;
    padding: 0px !important;
    height: 0px !important;
}

.text_style {
    height: 24px;
    font-family: sans-serif;
    font-size: 16px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.9px;
    color: #ffffff !important;
}

._header_margin {
    opacity: 0.5;
}
._span_text_sty {
    width: 5px;
    height: 24px;
    font-family: sans-serif;
    font-size: 16px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.9px;
    color: #ffffff;
    margin: 0px 36px;
    opacity: 0.5;
    display: inline-block;
    margin-top: 9px;
}
._span_img_sty {
    width: 5px;
    height: 24px;
    font-family: sans-serif;
    font-size: 16px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.9px;
    color: #ffffff;
    opacity: 0.5;
    margin: 0px 14px;
    display: inline-block;
    margin-top: 5px;
}
._project_img_sty {
    width: 22px;
    height: 24px;
    font-family: FontAwesome;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1.3px;
    color: rgba(255, 255, 255, 0.5);
}
._info_img_sty {
    width: 26px;
    height: 24px;
    opacity: 0.5;
    font-family: FontAwesome;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1.3px;
    color: #ffffff;
}
._account_img_sty {
    width: 19px;
    height: 24px;
    font-family: FontAwesome;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1.3px;
    opacity: 1;
    color: rgba(255, 255, 255, 0.5);
}
._search_header_sty {
    width: 71px;
    height: 38px;
    border-radius: 19.5px;
    border: solid 1.5px rgba(255, 255, 255, 0.5);
    margin: 11px 100px 11px 14px;
    box-sizing: border-box;
}
._header_nav_text:hover {
    display: inline-block;
    opacity: 1 !important;
    margin-bottom: 4px;
    cursor: pointer;
}
._header_nav_text_margin {
    display: inline-block !important;
    margin-top: 10px;
}
._header_nav_text_margin:hover {
    font-family: sans-serif;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.9px;
    color: #ffffff;
}
._header_nav_text_margin_no:hover{
    opacity: .5!important;
    margin-top: 10px!important;
    font-weight: 300!important;
    margin-bottom: 0px;
}
.navSpanClass {
    font-weight: 500;
    opacity: 1;
}
</style>

<style>
#headerId .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
    display: none;
}
#headerId .el-icon--right {
    visibility: hidden;
}
#headerId .el-dropdown-link {
    border: none;
    outline: none;
}
#headerId .el-icon-arrow-down {
    font-size: 12px;
}
.el-menu--popup-bottom-start {
    margin-top: -10px !important;
    min-width: 58px !important;
    text-align: center;
    margin-right: -20px !important;
}
div.el-menu--horizontal {
    position: absolute;
    left: 1022px !important;
    top: 74px !important;
}

#headerId .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
    background-color: #00b5e2 !important;
}
/* header */
#headerId .el-header {
    padding: 0px;
}
#headerId .el-menu-item {
    padding: 0px;
}
#headerId .el-submenu__title {
    margin: 0px;
    padding: 0px;
}
#headerId .el-menu-item.is-active {
    background-color: #00b5e2 !important;
}
#headerId .el-input--mini .el-input__inner {
    padding-left: 35px;
    transition: 0.2s;
    letter-spacing: 0.7px;
}

/* 新增 */

#headerId .el-header {
    line-height: 70px;
    background: #00b5e2;
}

#headerId .el-menu.el-menu--horizontal {
    border-bottom: none;
    float: right;
    background: #00b5e2;
}

#headerId .el-submenu:hover {
    background: #00b5e2 !important;
}

#headerId .el-menu--horizontal > .el-submenu:hover {
    background: #00b5e2 !important;
}

#headerId .header_image:hover {
    background: #00b5e2 !important;
}

#headerId .el-menu--horizontal > .el-menu-item {
    border: none !important;
    background: #00b5e2 !important;
    cursor: default;
}

#headerId .el-menu--horizontal > .el-submenu .el-submenu__title {
    border: none !important;
}

#headerId .is-active {
    background: #00b5e2 !important;
}

#headerId .el-menu-item:hover {
    background: #00b5e2 !important;
}

#headerId .el-tabs__item.is-active {
    background: #7b7b7b !important;
}

#headerId .text_style.is-active {
    background: #00b5e2 !important;
}
</style>
